import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class GetRegisteredApplicants {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute() {
    return this.applicantService.getRegisteredApplicants();
  }
}
